import "./App.scss";
import { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import Body from "./components/Body";
import Footer from "./components/Footer";
import Header from "./components/Header";
import FamilyTreePageV2 from "./components/FamilyTreePageV2";
import NotFound from "./components/NotFound";

function AppContent() {
  const [familyTreeName, setFamilyTreeName] = useState("");
  const location = useLocation();

  // Reset family tree name when not on family tree page
  useEffect(() => {
    if (!location.pathname.startsWith("/family/")) {
      setFamilyTreeName("");
    }
  }, [location.pathname]);

  return (
    <div className="App light h-dvh flex flex-col">
      <div className="grow-0">
        <Header familyTreeName={familyTreeName} />
      </div>
      <div className="grow">
        <Routes>
          <Route path="/" element={<Body />} />
          <Route
            path="/family/:slug"
            element={<FamilyTreePageV2 onFamilyTreeLoad={setFamilyTreeName} />}
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      <div className="grow-0">
        <Footer />
      </div>
    </div>
  );
}

function App() {
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");

  useEffect(() => {
    const appElement = document.querySelector(".App");
    if (appElement) {
      appElement.classList.remove("light", "dark");
      appElement.classList.add(theme);
    }

    const handleStorageChange = (e) => {
      if (e.key === "theme") {
        const newTheme = e.newValue || "light";
        setTheme(newTheme);
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, [theme]);

  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;
